import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { resolveAuthState } from "./Auth/AuthHooks/authApi";
import {
  getRouteFromCode,
  looksLikeJwt,
  getAccessToken,
} from "./Auth/AuthHooks/authRouting";
import { saveRedirectAfterAuth } from "./utils/redirectAfterAuth";

export default function ProtectedRoute({ children }) {
  const location = useLocation();

  const [state, setState] = useState({
    loading: true,
    redirectTo: null,
    allow: false,
  });

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      const token = getAccessToken();

      if (!looksLikeJwt(token)) {
        saveRedirectAfterAuth(location.pathname);
        if (mounted) {
          setState({
            loading: false,
            redirectTo: "/sign-in",
            allow: false,
          });
        }
        return;
      }

      const forcedRoute = sessionStorage.getItem("onboarding_force_route");
      const forcedStatus = sessionStorage.getItem("onboarding_force_status");
      const storedStatus =
        forcedStatus || localStorage.getItem("user_status") || null;

      if (forcedStatus) {
        localStorage.setItem("user_status", forcedStatus);
      }

      // consume-on-read: force-route — одноразовый хинт, не постоянный лок.
      // Иначе залипший ключ короткозамыкает роутинг в обход onboarding-pass-check.
      if (forcedRoute || forcedStatus) {
        sessionStorage.removeItem("onboarding_force_route");
        sessionStorage.removeItem("onboarding_force_status");
      }

      if (forcedRoute && location.pathname === forcedRoute) {
        if (mounted) {
          setState({
            loading: false,
            redirectTo: null,
            allow: true,
          });
        }
        return;
      }

      const auth = await resolveAuthState();

      if (!mounted) return;

      if (!auth.isAuthenticated) {
        saveRedirectAfterAuth(location.pathname);
        setState({
          loading: false,
          redirectTo: "/sign-in",
          allow: false,
        });
        return;
      }

      if (auth.onboardingStatus === "COMPLETED") {
        setState({
          loading: false,
          redirectTo: null,
          allow: true,
        });
        return;
      }

      if (typeof auth.onboardingStatus === "number") {
        const route = getRouteFromCode(auth.onboardingStatus, storedStatus);

        setState({
          loading: false,
          redirectTo: route || "/account-type-select",
          allow: false,
        });
        return;
      }

      setState({
        loading: false,
        redirectTo: "/account-type-select",
        allow: false,
      });
    };

    run();

    return () => {
      mounted = false;
    };
  }, [location.pathname]);

  if (state.loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (state.redirectTo) {
    const navState =
      state.redirectTo === "/sign-in"
        ? { from: location.pathname }
        : undefined;
    return <Navigate to={state.redirectTo} state={navState} replace />;
  }

  if (state.allow) {
    return children;
  }

  return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
}